export default "__VITE_ASSET__DGJpfOdn__"